"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function DeleteStickyButton({ className, onClick }) {
    const buttonRef = (0, react_1.useRef)(null);
    const onClickHandler = (event) => {
        event.stopPropagation();
        onClick();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(buttonRef, events.down, onClickHandler);
    return ((0, jsx_runtime_1.jsx)(Button, { ref: buttonRef, className: className, role: "button", "data-e2e": 'DeleteStickyButton_Button', children: (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Bin, "data-e2e": 'DeleteStickyButton_StyledIcon' }) }));
}
exports.default = DeleteStickyButton;
const Button = styled_components_1.default.div `
  position: absolute;
  top: -20px;
  left: -20px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.textSecondary};

  background: ${({ theme }) => theme.backgroundQuaternary};

  border-radius: 50%;

  box-shadow: ${({ theme }) => theme.tools.pen.button.shadow};

  transition: opacity 0.2s;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 20px;
  height: 20px;

  margin: auto;
`;
